import React from 'react'

const Loader = () => {
  return (
    <div className='d-flex  align-items-center justify-content-center h-100 w-100'>Loading... </div>
  )
}

export default Loader